/**
 * The two Pre-EP steps that live on outside sites. (The EP and welcome
 * session steps register for the events marked with that step in Event
 * Management.)
 */
export const PRE_EP_LINKS = {
  cultureIndex: "https://surveys.cultureindex.com/s/qYENXQW3Vn/60936",
  /** CertainPath Activation (QuickStart) course. */
  activationCourse: "https://share.articulate.com/OD1ritk6mjOkHQUTHy_eq",
} as const;
